import React, { Children, Fragment } from 'react'
import * as ReactDOM from 'react-dom'
import './index.less'

export interface PopoverProps {
  direction?: 'bottomLeft' | 'topLeft'   //  目前先支持上和小两种，均是左对齐
  width?:number                          // 宽度，默认为触发事件元素的宽度     
  height?:number                         // 高度，默认自适应
}

const stopBubbling = (e: any) => {
  e.nativeEvent.stopImmediatePropagation()
  e.stopPropagation()
  return false;
}

export const AppPopover =  {
  open<P>(
    component: React.ReactElement<P>,
    props?:PopoverProps,
    target?:any,
    render?:JSX.Element | string
  ): Promise<any> {

    target = target || event.target ;
    let targetRect = target.getBoundingClientRect()
    let direction = props && props.direction ? props.direction:'bottomLeft';
    let width : number= props && props.width ? props.width : targetRect.width;
    
    // bottomLeft
    let left = targetRect.left
    // bottomLeft
    let top = targetRect.top + targetRect.height
    // topLeft
    let bottom = targetRect.top

    let bodyWidth = document.body.clientWidth;
    let bodyHeight = document.body.clientHeight;

    // 如果下面的宽度不够，则将方向移到上面显示
    if(direction==='bottomLeft' && bodyHeight-top<150){
      direction = 'topLeft';
    }

    document.onclick = () => {
      this.close()
    }

    return new Promise(() => {
      if(document.querySelector('.app-popover')) return null;
      
      let popoverDiv = document.createElement('div');
      popoverDiv.className = 'app-popover'
      document.body.appendChild(popoverDiv);

      let content = (
                  <div className='app-popover-content'  
                      style={ direction==='bottomLeft'? {  left, top,width }:{left,bottom,width}}
                      onClick={e => stopBubbling(e)}
                      // onMouseOut = {e => stopBubbling(e)}
                  >
                      {component||render}
                  </div>)

      ReactDOM.render(content, popoverDiv)
    })
  },

  close() {
    document.onclick = null;
    if(document.querySelector('.app-popover')){
      document.body.removeChild(document.querySelector('.app-popover'))
    }
  }
}




// WEBPACK FOOTER //
// ./src/qcc/AppPopover/index.tsx